import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';
import Lottie from 'lottie-react';

// Context //
import { useLanguage } from '../../../Context/LanguageContext';
// Context //

// Model //
import CalculationFomulaModal from './CalculationFormulaModal';
// Model //

// Animation //
import LoadingAnimation from '../../../Animation/NewLoading.json';
// Animation //

// Utils //
import { formatPhoneNumber } from '../../../Utils/phoneUtils';
// Utils //

// Image //
import { ReactComponent as PersonSilhouetteSvg } from '../../../image/PersonSilhouette.svg';
// Image //


export default function MemberStatusBox(props) {
  const {
    allMembers,
    salesData,
    startDate,
    endDate,
    calcDateText,
    selectedPartnerGym,
    isOpenPartnerGymSales,
    isLoadingAllMember,
    isLoading,
    setIsLoading,
  } = props;

  const history = useHistory();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const { t, languageMode } = useLanguage();

  const [selectedTab, setSelectedTab] = useState('registered');
  const [registeredMembers, setRegisteredMembers] = useState([]);
  const [leaveMembers, setLeaveMembers] = useState([]);
  const [aliveMembers, setAliveMembers] = useState([]);
  const [registeredPrice, setRegisteredPrice] = useState(0);
  const [isViewFormulaModal, setIsViewFormulaModal] = useState(false);

  // 등록 회원, 이탈 회원, 유효 회원 구분 //
  useEffect(() => {
    if (isLoadingAllMember) return;

    let newRegisteredMembers = [];
    let newAliveMembers = [];
    let newLeaveMembers = [];

    for (let i = 0; i < allMembers.length; i++) {
      let isRegistered = false;
      let isAlive = false;
      let isLeave = false;

      // 등록 회원: 산정기간 내 startDate가 있는 회원 (신규 + 재등록 통합)
      for (let j = 0; j < allMembers[i].usages.length; j++) {
        if ((startDate.isBefore(allMembers[i].usages[j].startDate) || startDate.isSame(allMembers[i].usages[j].startDate))
          && (endDate.isAfter(allMembers[i].usages[j].startDate) || endDate.isSame(allMembers[i].usages[j].startDate))) {
          allMembers[i].startDate = allMembers[i].usages[j].startDate;
          isRegistered = true;
          break;
        }
      }

      // 유효 회원: endDate 이후까지 이용 중인 회원
      for (let j = 0; j < allMembers[i].usages.length; j++) {
        if (endDate.isBefore(allMembers[i].usages[j].endDate)) {
          isAlive = true;
          break;
        }
      }

      // 이탈 회원: 마지막 이용권의 endDate가 산정기간 내인 회원
      for (let j = 0; j < allMembers[i].usages.length; j++) {
        if (j === allMembers[i].usages.length - 1
          && startDate.isBefore(allMembers[i].usages[j].endDate)
          && endDate.isAfter(allMembers[i].usages[j].endDate)) {
          allMembers[i].endDate = allMembers[i].usages[j].endDate;
          isLeave = true;
          break;
        }
      }

      if (isRegistered) newRegisteredMembers.push(allMembers[i]);
      if (isAlive) newAliveMembers.push(allMembers[i]);
      if (isLeave) newLeaveMembers.push(allMembers[i]);
    }

    // 등록 회원: 최근 등록일 순 정렬
    newRegisteredMembers.sort(function (a, b) {
      let x = a.startDate;
      let y = b.startDate;

      if (x < y) return 1;
      if (x > y) return -1;
    });

    // 이탈 회원: 최근 이탈일 순 정렬
    newLeaveMembers.sort(function (a, b) {
      let x = a.endDate;
      let y = b.endDate;

      if (x < y) return 1;
      if (x > y) return -1;
    });

    setRegisteredMembers(newRegisteredMembers);
    setAliveMembers(newAliveMembers);
    setLeaveMembers(newLeaveMembers);

    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  }, [startDate, endDate, allMembers, isLoadingAllMember]);

  // 등록 회원 매출 계산 //
  useEffect(() => {
    if (salesData.length === 0 || allMembers.length === 0) return;

    let registeredMembersList = [];
    let newRegisteredPrice = 0;

    // 산정기간 내 approvalDate가 있는 회원 (신규 + 재등록 통합)
    for (let i = 0; i < allMembers.length; i++) {
      for (let j = 0; j < allMembers[i].usages.length; j++) {
        if ((startDate.isBefore(allMembers[i].usages[j].approvalDate) || startDate.isSame(allMembers[i].usages[j].approvalDate))
          && (endDate.isAfter(allMembers[i].usages[j].approvalDate) || endDate.isSame(allMembers[i].usages[j].approvalDate))) {
          registeredMembersList.push(allMembers[i]);
          break;
        }
      }
    }

    for (let i = 0; i < salesData.length; i++) {
      let isExist = false;

      for (let j = 0; j < registeredMembersList.length; j++) {
        if (salesData[i].memberId === registeredMembersList[j].memberId) {
          isExist = true;
          break;
        }
      }

      if (isExist) {
        newRegisteredPrice += (salesData[i].cardPrice + salesData[i].cashPrice);
      }
    }

    setRegisteredPrice(newRegisteredPrice);
  }, [salesData, allMembers]);

  // 계산식 호버 //
  function onMouseOverFormula() {
    setIsViewFormulaModal(true);
  }

  function onMouseLeaveFormula() {
    setIsViewFormulaModal(false);
  }

  // 회원 클릭시 상세 페이지 이동 //
  function onClickMember(memberId) {
    if (selectedPartnerGym === undefined || selectedPartnerGym.isMyStore) {
      history.push('/member/valid/detail/' + memberId);
    } else {
      history.push('/member/partner_gym/detail/' + memberId);
    }
  }

  // 전화번호 포맷 //
  function calcPhone(data) {
    if (!data.phone || data.phone === '') return t('statistics.noPhone');
    return formatPhoneNumber(data.phone, data.countryCode, languageMode) || t('statistics.noPhone');
  }

  // ISO 날짜 포맷 //
  function formatIsoDate(iso) {
    if (!iso) return '';
    const parts = iso.split('T')[0].split('-');
    return parts[0].slice(2) + '.' + parts[1] + '.' + parts[2];
  }

  // 현재 탭에 따른 데이터 //
  const isRegisteredTab = selectedTab === 'registered';
  const currentMembers = isRegisteredTab ? registeredMembers : leaveMembers;
  const currentRate = aliveMembers.length > 0
    ? Math.round((currentMembers.length / aliveMembers.length) * 100)
    : 0;
  const accentColor = isRegisteredTab ? (theme.primary || '#FF8333') : '#6DD49E';

  // 사람 아이콘 비율 렌더링 (currentRate 기준 10개 중 채워질 개수 결정) //
  function renderPeopleIcons() {
    const totalIcons = 10;
    const filledCount = Math.round((currentRate / 100) * totalIcons);

    return (
      <>
        <PeopleRow>
          {Array.from({ length: 5 }).map((_, i) => (
            <StyledPerson key={`top-${i}`} color={i < filledCount ? accentColor : theme.line} />
          ))}
        </PeopleRow>
        <PeopleRow>
          {Array.from({ length: 5 }).map((_, i) => {
            const idx = 5 + i;
            return (
              <StyledPerson key={`bottom-${i}`} color={idx < filledCount ? accentColor : theme.line} />
            );
          })}
        </PeopleRow>
      </>
    );
  }

  return (
    <TopLevelWrapper $isDark={isDark}>
      {
        isLoading ?
          <AnimationBox>
            <LottieWrapper>
              <Lottie animationData={LoadingAnimation} loop={true} />
            </LottieWrapper>
          </AnimationBox>
          :
          !isOpenPartnerGymSales ?
            <NotOpenWrapper>
              <Text fontFamily='NotoSansKR-Bold' fontSize={15} color={theme.subText} cursor='default'>{t('statistics.partnerGymPrivate')}</Text>
              <Text fontFamily='NotoSansKR-Regular' fontSize={15} color={theme.subText} cursor='default'>{t('statistics.partnerGymPrivateDesc')}</Text>
            </NotOpenWrapper>
            :
            <>
              <HeaderWrapper>
                <Text fontFamily='NotoSansKR-Bold' fontSize={20} color={theme.text} cursor='default'>{calcDateText()}</Text>
              </HeaderWrapper>
              
              {/* 상단 정보 행 */}
              <InfoRow>
                <InfoLeft>
                  {isRegisteredTab ? (
                    <RowWrapper gap={10}>
                      <Text fontFamily='NotoSansKR-Medium' fontSize={20} color={theme.text} cursor='default'>
                        {t('statistics.memberStatus.registeredSales')}
                      </Text>
                      <RowWrapper gap={5}>
                        <Text fontFamily='NotoSansKR-Bold' fontSize={20} color={theme.text} cursor='default'>
                          {registeredPrice.toLocaleString('ko-KR')}
                        </Text>
                        <Text fontFamily='NotoSansKR-Regular' fontSize={20} color={theme.subText} cursor='default'>
                          {t('statistics.won')}
                        </Text>
                      </RowWrapper>
                    </RowWrapper>
                  ) : (
                    <Text fontFamily='NotoSansKR-Medium' fontSize={20} color={theme.text} cursor='default'>
                      {t('statistics.memberStatus.churnedMembers')}
                    </Text>
                  )}
                </InfoLeft>
                <InfoRight>
                  <Text fontFamily='NotoSansKR-Medium' fontSize={20} color={theme.text} cursor='default'>
                    {isRegisteredTab
                      ? t('statistics.memberStatus.registrationRate')
                      : t('statistics.memberStatus.churnRate')}
                  </Text>
                  <Text fontFamily='NotoSansKR-Medium' fontSize={20} color={accentColor} cursor='default'>
                    {currentRate}%
                  </Text>
                  <Text fontFamily='NotoSansKR-Medium' fontSize={20} color={accentColor} cursor='default'>
                    {isRegisteredTab
                      ? '[ ' + t('statistics.memberMovement.total') + ' ' + currentMembers.length + t('statistics.personUnit') + ' ' + t('statistics.memberStatus.registered') + ' ]'
                      : '[ ' + t('statistics.memberMovement.total') + ' ' + currentMembers.length + t('statistics.personUnit') + ' ' + t('statistics.memberStatus.churned') + ' ]'}
                  </Text>
                </InfoRight>
              </InfoRow>

              {/* 메인 컨텐츠 영역 */}
              <ContentRow>
                {/* 왼쪽: 인포그래픽 + 계산식 + 토글 */}
                <LeftColumn>
                  <InfographicArea
                    onMouseOver={onMouseOverFormula}
                    onMouseLeave={onMouseLeaveFormula}>
                    {renderPeopleIcons()}

                    <CalculationFomulaModal
                      isView={isViewFormulaModal}
                      denominator={currentMembers.length.toLocaleString('ko-KR')}
                      denominatorText={isRegisteredTab
                        ? t('statistics.memberStatus.formulaRegisteredNumerator')
                        : t('statistics.memberStatus.formulaChurnedNumerator')}
                      numerator={aliveMembers.length.toLocaleString('ko-KR')}
                      numeratorText={t('statistics.memberStatus.formulaDenominator')}
                      result={currentRate}
                      resultUnit='%'
                      innerBoxBackgroundColor={theme.buttonFill}
                      componentBoxBackgroundColor={theme.subBackground}
                      accentColor={accentColor}
                      top={50}
                      left={20} />
                  </InfographicArea>

                  <ToggleWrapper>
                    <ToggleButton
                      $isActive={selectedTab === 'registered'}
                      $activeColor={theme.primary || '#FF8333'}
                      onClick={() => setSelectedTab('registered')}>
                      <Text fontFamily='NotoSansKR-Medium' fontSize={15}
                        color={selectedTab === 'registered' ? theme.subBackground : theme.text}
                        cursor='pointer'>
                        {t('statistics.memberStatus.tabRegistered')}
                      </Text>
                    </ToggleButton>
                    <ToggleButton
                      $isActive={selectedTab === 'churned'}
                      $activeColor='#6DD49E'
                      onClick={() => setSelectedTab('churned')}>
                      <Text fontFamily='NotoSansKR-Medium' fontSize={15}
                        color={selectedTab === 'churned' ? theme.subBackground : theme.text}
                        cursor='pointer'>
                        {t('statistics.memberStatus.tabChurned')}
                      </Text>
                    </ToggleButton>
                  </ToggleWrapper>
                </LeftColumn>

                {/* 오른쪽: 회원 목록 */}
                <RightColumn>
                  <ListTitleRow>
                    <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>
                      {isRegisteredTab
                        ? t('statistics.memberStatus.registeredList')
                        : t('statistics.memberStatus.churnedList')}
                    </Text>
                  </ListTitleRow>

                  <ListContainer>
                    <ListHeader>
                      <HeaderCell $flex={1}>
                        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>
                          {t('statistics.table.colName')}
                        </Text>
                      </HeaderCell>
                      <HeaderCell $width={70}>
                        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>
                          {t('statistics.table.colGender')}
                        </Text>
                      </HeaderCell>
                      <HeaderCell $flex={1}>
                        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>
                          {t('statistics.table.colPhone')}
                        </Text>
                      </HeaderCell>
                      <HeaderCell $width={100}>
                        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>
                          {isRegisteredTab
                            ? t('statistics.memberStatus.colRegDate')
                            : t('statistics.memberStatus.colChurnDate')}
                        </Text>
                      </HeaderCell>
                    </ListHeader>

                    <ListDivisionLine />

                    <ListBody $scrollBarColor={isDark ? accentColor : theme.scrollBar}>
                      {currentMembers.map((member, index) => (
                        <ListRow
                          key={index}
                          $accentColor={accentColor}
                          onClick={() => onClickMember(member.memberId)}>
                          <BodyCell $flex={1}>
                            <CellText fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text}>
                              {member.name}
                            </CellText>
                          </BodyCell>
                          <BodyCell $width={70}>
                            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='pointer'>
                              {member.gender === 'male' ? t('statistics.maleShort') : t('statistics.femaleShort')}
                            </Text>
                          </BodyCell>
                          <BodyCell $flex={1}>
                            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='pointer'>
                              {calcPhone(member)}
                            </Text>
                          </BodyCell>
                          <BodyCell $width={100}>
                            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='pointer'>
                              {isRegisteredTab
                                ? formatIsoDate(member.startDate)
                                : formatIsoDate(member.endDate)}
                            </Text>
                          </BodyCell>
                        </ListRow>
                      ))}
                    </ListBody>
                  </ListContainer>
                </RightColumn>

              </ContentRow>
            </>
      }
    </TopLevelWrapper>
  );
};

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  margin: 38px 0;
  padding: 20px 40px;

  width: 100%;
  max-width: 960px;
  height: 412px;

  gap: 10px;

  border-radius: 20px;
  box-shadow: ${props => props.$isDark ? 'none' : '0 40px 50px rgba(240, 232, 227, 0.5)'};
  background-color: ${props => props.theme.subBackground};
`;

const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
`;

const AnimationBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
  height: 448px;

  z-index: 5;

  background-color: ${props => props.theme.subBackground};
  border-radius: 20px;
`;

const LottieWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 160px;
  height: 160px;
`;

const NotOpenWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
  height: 448px;
`;

const InfoRow = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const InfoLeft = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;
`;

const InfoRight = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;

  gap: 10px;
`;

const RowWrapper = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;

  gap: ${props => props.gap}px;
`;

const ContentRow = styled.div`
  display: flex;
  flex-direction: row;

  gap: 30px;

  width: 100%;
  height: 338px;
`;

const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  justify-content: space-between;
  align-items: center;

  padding: 0 20px;

  overflow: clip;
`;

const InfographicArea = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  gap: 10px;

  width: 400px;
  flex: 1;

  cursor: pointer;
`;

const PeopleRow = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: flex-end;

  gap: 15px;
`;

const StyledPerson = styled(PersonSilhouetteSvg)`
  width: 50px;
  height: 109px;

  color: ${props => props.color};
`;

const ToggleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;

  padding: 5px;

  gap: 5px;

  height: 41px;

  margin-bottom: 20px;

  border-radius: 8px;
  background-color: ${props => props.theme.buttonFill3 || '#282828'};

  box-sizing: border-box;
`;

const ToggleButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 110px;
  height: 29px;

  border-radius: 6px;
  background-color: ${props => props.$isActive ? props.$activeColor : 'transparent'};
  box-shadow: ${props => props.$isActive ? '0px 9px 7.1px 0px rgba(0, 0, 0, 0.06)' : 'none'};

  cursor: pointer;

  transition: all 0.3s ease-in-out;
`;

/* 오른쪽 회원 목록 영역 */
const RightColumn = styled.div`
  display: flex;
  flex-direction: column;

  gap: 10px;

  width: 480px;
`;

const ListTitleRow = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;

  padding-top: 20px;

  width: 100%;
`;

const ListContainer = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
`;

const ListHeader = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;

  height: 30px;

  padding: 0 10px 0 10px;
`;

const HeaderCell = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;

  ${props => props.$flex ? `flex: ${props.$flex}; min-width: 0;` : ''}
  ${props => props.$width ? `width: ${props.$width}px; flex-shrink: 0;` : ''}

  overflow: clip;
`;

const ListDivisionLine = styled.div`
  width: 100%;
  height: 1px;

  opacity: 0.5;
  background-color: ${props => props.theme.line};

  margin: 0 0 0 0;
`;

const ListBody = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  max-height: 246px;

  overflow-y: auto;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 2px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 50px;
    background-color: ${props => props.$scrollBarColor};
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
    border-radius: 200px;
  }
`;

const ListRow = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;

  padding: 10px 10px;

  width: calc(100% - 20px);

  border-radius: 5px;

  background-color: ${props => props.theme.subBackground};

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    background-color: ${props => props.$accentColor};

    p {
      color: ${props => props.theme.subBackground};
    }
  }
`;

const BodyCell = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;

  ${props => props.$flex ? `flex: ${props.$flex}; min-width: 0;` : ''}
  ${props => props.$width ? `width: ${props.$width}px; flex-shrink: 0;` : ''}

  overflow: hidden;
`;

const CellText = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:hover {
    cursor: pointer;
  }
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  white-space: nowrap;

  &:hover {
    cursor: ${props => props.cursor};
  }
`;
